import { Component, ViewChild } from '@angular/core';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ApiService } from 'app/api.service';
import { ModalEditProjectComponent } from 'app/modal/modal-edit-project/modal-edit-project.component';
import { Pagination } from 'app/shared/pagination';
import { AppService } from 'app/app.service';
import { ProjectService } from 'app/project/project.service';

declare const Mangler: any;
@Component({
	selector: 'app-modal-select-project',
	templateUrl: './modal-select-project.component.html',
	styles: [`
		.sticky-tabs {
			position: sticky;
			top: -1.5rem;
			z-index: 10;
			background-color: #fff;
		}

		tr .sticky {
			top: 3.4rem;
		}
	`]
})
export class ModalSelectProjectComponent extends UIModalBaseComponent {

	@ViewChild(ModalEditProjectComponent) editProjectModal: ModalEditProjectComponent;

	projects;
	projectSearchList = '';
	projectSortList = '';
	selectedId = null;
	pagination = new Pagination();
	customer_id;
	// The currency the caller can accept. A project's currency is fixed at creation and its
	// quotes have to match it, so a caller already committed to one — the CRM's deal, say — can
	// only ever use projects in it, and offering the others is offering a refusal.
	currency_id = null;
	status = ['active', 'completed', 'cancelled'];
	labelList = [];
	labelFilter = [];
	mode = 'select';
	tab;
	statusData = {
		all: { list: [], count: 0, total: 0 },
		active: { list: [], count: 0, total: 0 },
		completed: { list: [], count: 0, total: 0 },
		cancelled: { list: [], count: 0, total: 0 },
		not_invoiced: { list: [], count: 0, total: 0 },
		draft: { list: [], count: 0, total: 0 },
		unpaid: { list: [], count: 0, total: 0 },
		paid: { list: [], count: 0, total: 0 }
	};

	open(_data: any) {
		this.customer_id = _data.customer_id || null;
		this.currency_id = _data.currency_id || null;
		this.mode = _data.mode || 'select';
		this.tab = _data.tab || null;
		this.refresh();
	}

	constructor(
		public app: AppService,
		private api: ApiService,
		public service: ProjectService
	) {
		super();
	}

	refresh() {
		this.api.settings.listLabels({
			type: ['project']
		}, data => {
			this.labelList = data || [];
			this.labelFilter = [];
			this.refreshList();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});

		this.api.project.listActiveProjects(list => {
			this.projects = list;
			this.modal.open();
		});
	}

	refreshList() {
		this.api.project.list({
			sort: this.projectSortList,
			labels: this.getFilteredValue(this.labelFilter),
			...(this.customer_id != null && { customer: [this.customer_id] }),
			...(this.currency_id != null && { currency: this.currency_id })
		}, projects => {
			this.projects = projects;
			this.statusData = {
				all: { list: [], count: 0, total: 0 },
				active: { list: [], count: 0, total: 0 },
				completed: { list: [], count: 0, total: 0 },
				cancelled: { list: [], count: 0, total: 0 },
				not_invoiced: { list: [], count: 0, total: 0 },
				draft: { list: [], count: 0, total: 0 },
				unpaid: { list: [], count: 0, total: 0 },
				paid: { list: [], count: 0, total: 0 }
			};

			this.projects.list.forEach(project => {
				project.statusList = [];

				this.statusData.all.list.push(project);
				this.statusData.all.count += 1;
				this.statusData.all.total += project.net_total * project.primary_rate;

				if (project.status === 'active') {
					project.statusList.push('active');
					this.statusData.active.list.push(project);
					this.statusData.active.count += 1;
					this.statusData.active.total += project.net_total;
				} else if (project.status === 'completed') {
					project.statusList.push('completed');
					this.statusData.completed.list.push(project);
					this.statusData.completed.count += 1;
					this.statusData.completed.total += project.net_total;
				} else if (project.status === 'cancelled') {
					project.statusList.push('cancelled');
					this.statusData.cancelled.list.push(project);
					this.statusData.cancelled.count += 1;
					this.statusData.cancelled.total += project.net_total;
				}

				if (project.not_invoiced_total > 0.005) {
					project.statusList.push('not_invoiced');
					this.statusData.not_invoiced.list.push(project);
					this.statusData.not_invoiced.count += 1;
					this.statusData.not_invoiced.total += project.not_invoiced_total * project.primary_rate;
				}

				if (project.draft_total > 0.005) {
					project.statusList.push('draft');
					this.statusData.draft.list.push(project);
					this.statusData.draft.count += 1;
					this.statusData.draft.total += project.draft_total * project.primary_rate;
				}

				if (project.outstanding_total > 0.005) {
					project.statusList.push('unpaid');
					this.statusData.unpaid.list.push(project);
					this.statusData.unpaid.count += 1;
					this.statusData.unpaid.total += project.outstanding_total * project.primary_rate;
				}

				if (project.paid_total > 0.005) {
					project.statusList.push('paid');
					this.statusData.paid.list.push(project);
					this.statusData.paid.count += 1;
					this.statusData.paid.total += project.paid_total * project.primary_rate;
				}

				if (project.labels) project.labels = JSON.parse(project.labels);
			});
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	// Helper function to determine filtered value or null
	getFilteredValue(filterArray) {
		return (filterArray.length === 0) ? null : filterArray;
	}

	handleLabelChange(data) {
		this.labelFilter = Mangler.clone(data);
		this.refreshList();
	}

	clearAllFilters() {
		this.labelFilter = [];
		this.refreshList();
	}

	isAnyFilterActive(): boolean {
		const filters = [
			this.labelFilter
		];

		return filters.some(filter => filter.length > 0);
	}

	getLabelData(id) {
		if (!this.projects.labels) return;
		return this.projects.labels.find(item => item.id === id);
	}

	sortClass(field) {
		if (this.projectSortList === field) return 'wq wq-caret-up text-secondary text-large';
		if (this.projectSortList === '!' + field) return 'wq wq-caret-down text-secondary text-large';
		return '';
	}

	sortBy(field) {
		if (this.projectSortList === field) {
			this.projectSortList = '!' + field;
		} else {
			this.projectSortList = field;
		}

		this.refreshList();
	}

	statusList() {
		return ['all', 'active', 'completed', 'cancelled', 'not_invoiced', 'draft', 'unpaid', 'paid'];
	}

	statusColor(status, selected = true, defaultColor = 'secondary') {
		if (!selected) return defaultColor;

		switch (status) {
			case 'all': return 'primary';
			case 'active': return 'info';
			case 'completed': return 'success';
			case 'cancelled': return 'danger';
			case 'not_invoiced': return 'secondary';
			case 'draft': return 'info';
			case 'unpaid': return 'warning';
			case 'paid': return 'success';
		}
		return 'secondary';
	}

	statusDescription(status) {
		switch (status) {
			case 'all': return 'All';
			case 'active': return 'Active';
			case 'completed': return 'Completed';
			case 'cancelled': return 'Cancelled';
			case 'not_invoiced': return 'Not Invoiced';
			case 'draft': return 'Draft';
			case 'unpaid': return 'Unpaid';
			case 'paid': return 'Paid';
		}
		return '';
	}

	selectStatusFilter(status) {
		if (this.service.statusFilter === status) return;

		this.service.statusFilter = status;
		this.refreshList();
	}

	statusTotal(s) {
		if (this.statusData[s]) return this.statusData[s].total;
		return 0;
	}

	statusCount(s) {
		if (this.statusData[s]) return this.statusData[s].count;
		return 0;
	}

	statusProjects(s) {
		if (this.statusData[s]) return this.statusData[s].list;
		return [];
	}

	addProject() {
		this.editProjectModal.open({ customerId: this.customer_id, currencyId: this.currency_id });
	}

	editProjectModalClosed(data) {
		this.modal.close(data);
	}

	selectItem(item) {
		this.modal.close(item);
	}

	checkJobCount(item) {
		if (!this.tab) return false;
		const countMap = {
			project_job: item.project_job_count,
			service_job: item.service_job_count
		};
		return countMap[this.tab] > 0;
	}

}
